import React, { useEffect,useCallback, useRef,useMemo, useState } from 'react';
// import AgGrid from "./AgGrid"
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { columnwithDefs } from "./columnDefs_vehicles";
import Constants from "./Masters_constants";
import redirectURL from "../redirectURL";
import EditItem from './EditItem'
import DeletePartner from './deleteItem'
import SweetAlert from 'react-bootstrap-sweetalert';
import { getHyphenDDMMMYYYYHHMM } from '../common/utils';
import { format } from 'date-fns';
import BulkUploadModal from './BulkUploadModal.js';

function Masters() {
    var [rowData, setRowData] = useState([])
    var [columnDefs1, setColumnDefs1] = useState([
        {
            headerName: "Action",
            field: "_id",
            resizable: true,
            width: 90,
            filter: false,
            cellRenderer: EditItem,
            pinned: "left",
                headerClass: 'bold-header'
            // editable: false
        },
        {
            headerName: "",
            field: "_id",
            width: 50,
            cellRenderer: DeletePartner,
            pinned: "left",
                headerClass: 'bold-header'
        }
        
    ])
    const vehicleMasterColumns = [
        {
            headerName: "Vehicle Type",
            field: "vehicle_type",
            width: 240,
            filter: true,
                headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Capacity",
            field: "vehicle_capacity",
            width: 240,
            filter: true,
                headerClass: 'bold-header'
    
        }
    ];
    var [columnDefs, setColumnDefs] = useState([...columnDefs1, ...vehicleMasterColumns])

    // var [showloaderbg, setshowloaderbg] = useState("show-m");
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    var [showloader, setshowloader] = useState("show-m");
    var [showAddSlider, setshowAddSlider] = useState("");
    var [overlay, setoverlay] = useState("show-n");
    var [rowid ,setRowId] = useState();
    var [sliderText, setSliderText] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    var [vehicle_capacity, setvehiclecapacity] = useState("");
    var [vehicle_type, setvehicletype] = useState("");
    var [is_active, setstatus] = useState("");
    // var modules = useState(AllModules);
    var paginationPageSize = useState(50);

    var [show, setShow] = useState(false);
    var [basicType, setBasicType] = useState("");
    var [basicTitle, setBasicTitle] = useState("");
    var [deleteConfirmationSlide, setDeleteConfirmationSlide] = useState("");
    var [deleteRowData, setDeleteRowData] = useState("");
    

    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            resizable:true,
            sortable: true,
            filter: true,
            editable:false

        };
    }, []);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const onClickOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
        setoverlay("show-m")
    };

    const closeBulkUploadModal = () => {
        setShowBulkUploadModal(false);
        setoverlay("show-n")

    };

    var onGridReady = (params) => {
        // gridApi = params.api;
		// gridColumnApi = params.columnApi;
        console.log('params',params)
        console.log('Grid Ready. Column API:', params.columnApi);
        // gridApiRef.current = params.api; 
        // gridColumnApiRef.current = params.columnApi;
    }

    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const getCurrentFormattedDate = () => {
        const date = new Date();
        return format(date, 'dd-MM-yyyy');
    };

    const getCurrentISODate = () => {
        const date = new Date();
        return date.toISOString();
    };

    useEffect(() => {
        setTimeout(() => {
            // setshowloaderbg("show-n")
            setshowloader("show-n")
        }, 2000)
        loadData();

        // 
    }, [])

    var loadData = async () => {
        var parameters = {}
        await redirectURL.post('/getVehicleDetails', parameters)
            .then(response => {
                if (response.data.status == "success") {
                    setRowData(response.data.records);
                }
                // setshowloaderbg("show-n");
                setshowloader("show-n");

            })
            .catch(error => console.error('Error fetching data:', error));
    }
    var onClickDeleteItem = async (rownode) => {
        // console.log("Rownode Update", rownode);
        setDeleteConfirmationSlide("slide95")
        setoverlay("show-m")
        setDeleteRowData(rownode)
    };

    var onsubmitdelete = async (rownode) => {
        // console.log("Rownode Update", rownode);
        var params = {
            row_id: deleteRowData.data._id
        }
    
        try {
            const resp = await redirectURL.post('/deleteVehicleDetails', params);
            console.log(resp,"resp",resp.data.status,"success");
            
            if (resp.data.status === "success") {
                setDeleteConfirmationSlide("")
                setoverlay("show-n");
                setshowloader("show-n");
                setShow(true);
                setBasicTitle("Vehicle Deleted Successfully");
                setBasicType("success");
                loadData();
            }
        } catch (error) {
            console.error("Error deleting vehicle details:", error);
        }
    };
    var hideDeleteSubmit = ()=>{
        setDeleteConfirmationSlide("");
        setoverlay("show-n");
    
    }
    
    var showAddBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m")
        setSliderText("Add Vehicle");
        setvehiclecapacity("");
        setvehicletype("");
        setIsEditMode(false);

    }

    var onClickEditBlock  = async (rownode) =>{
        console.log("rownode ", rownode)
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m");
        setSliderText("Edit Vehicle");
        setRowId(rownode.data._id);
        setvehiclecapacity(rownode.data.vehicle_capacity);
        setvehicletype(rownode.data.vehicle_type);
        setIsEditMode(true);
    }

    var hideAll = () => {
        setoverlay("show-n");
        setshowAddSlider("");
    }


    var saveMasterForm = async (e) => {
        e.preventDefault();
        let user_email = localStorage.getItem('email');
        // setshowloaderbg("show-m");
        const createdDate = getCurrentISODate();
        setshowloader("show-m")
        if(isEditMode) {
            var params = {
                rowid: rowid,
                vehicle_capacity: vehicle_capacity,
                vehicle_type: vehicle_type,
                // is_active: is_active,
                modified_date: createdDate,
            }
        }
        else {
            var params = {
                vehicle_capacity: vehicle_capacity,
                vehicle_type: vehicle_type,
                // is_active: is_active,
                created_date: createdDate,
            }
        }
        
        console.log(params, "params");
        console.log(isEditMode, "edit mode");
        if (isEditMode) {
            await redirectURL.post('/updateVehicleMaster', params).then((resp) => {
                console.log(resp, "edit response");
                if (resp.data.status == "success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setshowloader("show-n");
                    setvehicletype("");
                    setvehiclecapacity("");
                    setstatus("");
                    setIsEditMode(false);
                    setRowId("");
                    setShow(true);
                    setBasicTitle("Updated Vehicle Data");
                    setBasicType("success");
                    loadData();
                }
            });
        } else {
            await redirectURL.post('/addVehicle', params).then((resp) => {
                if (resp.data.status == "success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setvehicletype("");
                    setvehiclecapacity("");
                    setstatus("");
                    setIsEditMode(false);
                    setShow(true);
                    setBasicTitle("Added Vehicle Data");
                    setBasicType("success");
                    loadData();
                } else if (resp.data.status === "failure") {
                    setoverlay("show-n");
                    setshowloader("show-n");
                    setIsEditMode(false);
                    setshowAddSlider("");
                    setvehicletype("");
                    setvehiclecapacity("");
                    setstatus("");
                    setShow(true);
                    setBasicTitle(resp.data.message);
                    setBasicType("danger");
                }
            }).catch(err => {
            });
        }
    };

    var handleVehicleType = (e) => {
        // if (isEditMode) return;
    
        var inputValue = e.target.value;
        var validInput = inputValue.replace(/[^a-zA-Z0-9\s]/g, '');
    
        if (validInput.length <= 100) {
            setvehicletype(validInput);
        } else {
            setvehicletype("");
        }
    }    

    var handleVehicleCapacity = (e) => {
        // if (isEditMode) return;
    
        var inputValue = e.target.value;
        var validInput = inputValue.replace(/[^0-9]/g, '');
    
        // Check if the first character is not 0
        if (validInput.length > 0 && validInput[0] === '0') {
            validInput = validInput.substring(1);
        }
    
        if (validInput.length <= 10) {
            setvehiclecapacity(validInput);
        } else {
            setvehiclecapacity("");
        }
    }            

    return (
        <div>
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={() => {
                        setShow(false)
                    }}>
                </SweetAlert>


            </div>
            <div className="container-fluid">
    {/* Header Row for Heading and Buttons */}
    <div className="row align-items-center justify-content-between mb-3">
        {/* Heading */}
        <div className="col-auto">
            <h5 className="f18 d-flex align-items-center master-title">
                <i className="icofont icofont-vehicle-delivery-van cus-i"></i>&nbsp;Vehicle Master
            </h5>
        </div>

        {/* Buttons */}
        <div className="col-auto d-flex">
            <button
                title="Bulk Upload"
                onClick={onClickOpenBulkUploadModal}
                className="btn btn-warning mr-2"
                type="button"
                style={{ padding: "8px 15px", height: "35px" }}
            >
                <i className="fa fa-upload"></i>&nbsp;Upload Vehicles
            </button>

            <BulkUploadModal
                show={showBulkUploadModal}
                onClose={closeBulkUploadModal}
                columnDefs={vehicleMasterColumns}
                screen={"vehicle_master"}
                templateUrl={require('../../assets/json/vehicle_master_template.csv')}
            />

            {Constants.VEHICLES.BTN_ADD === 1 && (
                <button
                    className="btn btn-warning"
                    onClick={showAddBlock}
                    style={{ padding: "8px 15px", height: "35px" }}
                >
                    <i className="icon-plus"></i>&nbsp;Add Vehicle
                </button>
            )}
        </div>
    </div>

    {/* Grid Section */}
    <div className="row">
        <div className="col-xl-12 col-md-12">
            <div className="card">
                <div className="card-body">
                    <div
                        className="ag-theme-balham mt-3"
                        style={{ height: "500px", width: "100%" }}
                    >
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={rowData}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            paginationPageSize={50}
                            onGridReady={onGridReadyConsignments}
                            enableRangeSelection={true}
                            enableCellContextMenu={true}
                            masterDetail={true}
                            context={{ onClickEditBlock, onClickDeleteItem }}
                            sideBar={{
                                toolPanels: [
                                    {
                                        id: "columns",
                                        labelDefault: "Columns",
                                        labelKey: "columns",
                                        iconKey: "columns",
                                        toolPanel: "agColumnsToolPanel",
                                        toolPanelParams: {
                                            suppressPivotMode: true,
                                            suppressRowGroups: true,
                                            suppressValues: true,
                                        },
                                    },
                                    {
                                        id: "filters",
                                        labelDefault: "Filters",
                                        labelKey: "filters",
                                        iconKey: "filter",
                                        toolPanel: "agFiltersToolPanel",
                                    },
                                ],
                            }}
                            statusBar={{
                                statusPanels: [
                                    {
                                        statusPanel: "agTotalAndFilteredRowCountComponent",
                                        align: "left",
                                    },
                                    {
                                        statusPanel: "agTotalRowCountComponent",
                                        align: "center",
                                    },
                                    { statusPanel: "agFilteredRowCountComponent" },
                                    { statusPanel: "agSelectedRowCountComponent" },
                                    { statusPanel: "agAggregationComponent" },
                                ],
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

            {/* <div className={"overlay-part " + (overlay)} onClick={hideAll}></div> */}

            <div className={"slide-r " + showAddSlider}>
                <div className="slide-r-title">
                    <h4 className="slide-r-title">{sliderText}
                        <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={hideAll} >X</span>

                    </h4>

                </div>
                <div className="slide-r-body">

                    <form className="" style={{ padding: "20px" }} onSubmit={saveMasterForm}>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Vehicle Type<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="vehicle_type" value={vehicle_type} style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#f9f9f9",
                            }} onChange={handleVehicleType} required />
                        </div>

                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Vehicle Capacity<span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="number"
                                name="vehicle_capacity"
                                id="vehicle_capacity"
                                value={vehicle_capacity}
                                onChange={handleVehicleCapacity}
                                required
                                // disabled={isEditMode}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9f9f9",
                                }}
                            />
                        </div>

                        {isEditMode ? 
                        <>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Update Vehicle</button>
                        </div>
                        </>
                        :
                        <>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Vehicle</button>
                        </div>
                        </>
                        }
                        {/* <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Transporter</button>
                        </div> */}

                    </form>
                </div>

            </div>
            {deleteConfirmationSlide
                 && 
                 <div className={"sliderBlock3 " + (deleteConfirmationSlide)} >
                <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideDeleteSubmit} >
                    <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                </span>
                <div className='d-flex mt-60p' style={{marginLeft:"42px"}}>
                            <div className='d-flex flex-column ml-20p'>
                                <h1 className='confirm-heading'>Are you sure you want to delete ?</h1>
                            </div>
                </div>                
                <div className='d-flex flex-row ml-30p mt-20p'>
                    <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideDeleteSubmit} >Cancel</button>
                    <button className='btn_hover8' onClick={onsubmitdelete}>Delete</button>
                </div>

                </div>}

            <div className={"dataLoadpage " +(showloader)}>
                </div>
                <div className={"dataLoadpageimg " +(showloader)}>
                    <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part "+(overlay)} onClick={hideAll}></div>


        </div>
    );
}

export default Masters;
